import type { PageHeader } from '@jet-app/music-classical/models';
import { type ObjectGraph } from '@jet/environment/dependencies';
import type { ClassicalAPIResponseHeader } from '@jet-app/music-classical/api/types';
import { makeSortAccessoryButton } from '@jet-app/music-classical/models/section/AccessoryButton';

export function makePageHeader(
    responseHeader: ClassicalAPIResponseHeader,
    objectGraph?: ObjectGraph,
): PageHeader {
    const sortConfig = responseHeader.sorting?.reduce(
        (acc, sortOption) => {
            const id = sortOption.title.toLowerCase().replaceAll(' ', '_');

            acc.items.push({
                id,
                label: sortOption.title,
                action: sortOption.action,
            });

            if (sortOption.isSelected) {
                if (sortOption.order === 'descending') {
                    acc.sortBy = `-${id}`;
                } else {
                    acc.sortBy = id;
                }
                acc.sortOrderAction = sortOption.action;
                acc.isReversible = sortOption.reversible;
            }

            return acc;
        },
        { items: [], sortBy: '', sortOrderAction: {}, isReversible: false },
    );

    return {
        ...responseHeader,
        sorting: makeSortAccessoryButton('sorts', sortConfig),
    } as PageHeader;
}
